// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.OneTimeRenterPaymentWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment } from '@zg-rentals/ts-rent-payment-client';

import type { OneTimeRenterPaymentWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Args {
  postData: OneTimeRenterPaymentWebApiRequestDto;
}

export type OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Options = UseMutationOptions<
  void,
  unknown,
  OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Args
>;

/**
 * One Time Renter Payment
 */
export const useOneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment = ({
  httpClient,
  ...options
}: Omit<OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment_Args) =>
      OneTimeRenterPaymentWebApiHandler_oneTimeRenterPayment(args.postData, httpClient),
  });
};
